import React, { useState } from 'react';
import { useAuth } from './auth';
import { GoogleLogin } from '@react-oauth/google';


export function LoginPage({onLogin, onSuccess}) {
  const { login, user } = useAuth();
  const [err, setErr] = useState('');

  const handleTrainerDemoLogin = async () => {
    setErr('');
    const res = await login({ username: 'trainer', password: '1234' });
    if (!res.success) setErr('Invalid demo credentials.');
  }

  if (user) {
    // If user is already logged in, redirect to dashboard
    // window.location.href = '/';
    return (<>
    <div>
      You are logged in!
      </div></>); // Prevent rendering the form
  }
  return (
    <div className="ptc-card" style={{
      margin: '0rem auto', 
      borderRadius: 12, 
      boxShadow: '0 4px 24px rgba(0,0,0,0.08)', 
      padding: '2rem',
      maxWidth: 400
    }}>
      {/* Trainer login only */}
      <>
        <div style={{textAlign: 'center', marginTop: 16, marginLeft: 'auto',
          marginRight: 'auto', width: 'fit-content'}}>
          <GoogleLogin
            center
            className="ptc-button"
            onSuccess={onSuccess}
            onError={() => {
              setErr('Google login failed.');
            }}
            useOneTap
          />
        </div>
        {err && <div style={{color: 'red', marginTop: 16, textAlign: 'center'}}>{err}</div>}
      </>
    </div>
  );
}
